Vue.component("RefillLegalMention", {
    props: {
        contractualDocument: {
            type: Object,
            required: true
        },
        legalMentions: {
            type: Array,
            required: false,
            default: function () {
                return []
            }
        }
    },
    template: `
        <div>
            <div class="container-fluid bg-gray2 py-2">
                <div class="row">
                    <div class="col-12 mx-auto">
                        <div id="legal-mentions">
                            <ob1-liens-haut-bas :button-id="'legal-mentions-header'"
                                                :collapsed-block-id="'legal-mentions-text'"
                                                :button-label="contractualDocument.legalTitle"
                                                :is-mini="true"
                                                :is-collapsed="false">
                                <div class="row">
                                    <div class="col-12">
                                        <p class="small p-0"
                                           v-html="contractualDocument.legalText"></p>
                                        <div v-for="(legalMention) in legalMentions">
                                            <p class="small p-0"
                                               v-html="legalMention.legalText"></p>
                                        </div>
                                    </div>
                                </div>
                            </ob1-liens-haut-bas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
});
